import { CommonSynopticTemplate } from '@/api/resources/common/synoptic-template-services/synoptic-template.model'
import axios from 'axios'

class CommonSynopticTemplateService {
    async findAllIndexTemplates(laboratoryId: number): Promise<CommonSynopticTemplate[]> {
        const response = await axios.get<CommonSynopticTemplate[]>(`laboratories/${laboratoryId}/synopticTemplates`)
        return response.data
    }

    async findCompatibleIndexTemplates(laboratoryId: number, caseId: number, sampleId: number): Promise<CommonSynopticTemplate[]> {
        const response = await axios.get<CommonSynopticTemplate[]>(`laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/synopticTemplates/compatible`)
        return response.data
    }

    async findTemplateById(templateId: number): Promise<CommonSynopticTemplate> {
        const response = await axios.get<CommonSynopticTemplate>(`synopticTemplates/${templateId}`)
        return response.data
    }
}
export const commonSynopticTemplateService = new CommonSynopticTemplateService()
